import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, ReportRunService, ReportSpecificationService } from '@scisys-uim/uim-common';
import { Observable } from 'rxjs';
import { AssetService } from './asset.service';

export type COMPOSED_ASSET_CLASS_CODE = "Asset" | "Firearm";

export interface AssetTagsConfig {
  delimiter: string,
  separators: string[],
  sanitizedSeparator: string,
}

@Injectable({
  providedIn: 'root'
})
export class AssetTagsService extends AssetService {

  public tagConfig: AssetTagsConfig = {
    delimiter: ",",
    separators: [" ", "-", "_"],
    sanitizedSeparator: " ",
  }

  constructor(protected reportRunService: ReportRunService,
    protected reportSpecificationService: ReportSpecificationService,
    http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(reportRunService, reportSpecificationService, http, environment);
    this.loadConfig();
  }

  public loadConfig() {
    this.getTagConfig().subscribe(
      data => {
        if (data.delimiter != null) {
          this.tagConfig.delimiter = data.delimiter;
        }
        if (data.separators != null) {
          this.tagConfig.separators = data.separators;
        }
        if (data.sanitizedSeparator != null) {
          this.tagConfig.sanitizedSeparator = data.sanitizedSeparator;
        }
      }
    );
  }

  public sanitizeTag(tag: string): string {
    if (tag == null) {
      return null;
    }
    var sanitizedTag = tag.trim();
    sanitizedTag = sanitizedTag.toLowerCase();
    for (let separator of this.tagConfig.separators) {
      const regex = new RegExp(separator, 'g');
      sanitizedTag = sanitizedTag.replace(regex, this.tagConfig.sanitizedSeparator);
      sanitizedTag = sanitizedTag.replace(/\s+/g, ' ');
      sanitizedTag = sanitizedTag.trim();
    }
    if (sanitizedTag == '') {
      return null;
    }
    return sanitizedTag;
  }

  public matchingTagPartial(searchString: string, tag: string) {
    return this.sanitizeTag(tag).startsWith(this.sanitizeTag(searchString));
  }

  public matchingTagExact(searchString: string, tag: string) {
    return this.sanitizeTag(tag) == this.sanitizeTag(searchString);
  }

  public findAllTagsForAssetClass(assetClass: COMPOSED_ASSET_CLASS_CODE): Observable<string[]> {
    return this.http.get<string[]>(this.getUrlBaseFindAll() + '/findAllTagsForAssetClass/' + assetClass);
  }

  public getTagConfig(): Observable<AssetTagsConfig> {
    return this.http.get<AssetTagsConfig>(this.getUrlBaseFindAll() + '/getTagConfig');
  }

}